import React, {
    useEffect,
    useState,
    useCallback,
    memo,
    useRef,
  } from 'react';
  import { Box, Divider, Typography } from '@mui/material';
  import { useParams } from 'react-router-dom';
  import { useApi } from '../../../../../shared/hooks/useApi';
  import { TCAppConfig } from '../../../../../shared/app-configs/tc-app-configs';
  import CustomTable from '../../../../../shared/components/table/custom-table';
import { fetchShipmentDetails } from './shipment-api';
import { LoaderComponent } from '../../../../../shared/components/loaders/page-loader';
  
  interface RenderDetailPanelProps {
    row: any;
  }
  
  // Explicit column definitions for the detail panel
  const detailColumns = [
    // {
    //   accessorKey: 'tcShipmentConsigneeOrder',
    //   header: 'Consignee Order',
    //   minSize: 100,
    //   maxSize: 200,
    // },
    {
      accessorKey: 'consigneeName',
      header: 'Consignee Name',
      minSize: 100,
      maxSize: 200,
    },
    {
      accessorKey: 'isConsigneeTeCertified',
      header: 'TE Certified?',
      minSize: 100,
      maxSize: 200,
    },
    {
      accessorKey: 'consigneeAddress1',
      header: 'Address 1',
      minSize: 100,
      maxSize: 200,
    },
    // {
    //   accessorKey: 'consigneeAddress2',
    //   header: 'Address 2',
    //   minSize: 100,
    //   maxSize: 200,
    // },
    // {
    //   accessorKey: 'consigneeAddress3',
    //   header: 'Address 3',
    //   minSize: 100,
    //   maxSize: 200,
    // },
    {
      accessorKey: 'consigneePostcode',
      header: 'Postcode',
      minSize: 80,
      maxSize: 150,
    },
    {
      accessorKey: 'consigneeTown',
      header: 'Town',
      minSize: 100,
      maxSize: 200,
    },
    {
      accessorKey: 'consigneeStateOrProvinceDescription',
      header: 'State/Province',
      minSize: 100,
      maxSize: 200,
    },
    {
      accessorKey: 'consigneeCountryOrAreaDescription',
      header: 'Country/Area',
      minSize: 100,
      maxSize: 200,
    },
  ]
  
  const RenderDetailPanel = memo(({ row }: RenderDetailPanelProps) => {
    const rowData = row.original; // Data from the main table row
    const { TE_ID } = useParams();
  
    // Custom hook for API calls
    const { loading, executeGet } = useApi();
  
    // Local state to store the fetched shipment data and error
    const [shipmentData, setShipmentData] = useState<any>(null);
    const [error, setError] = useState<string | null>(null);
  
    // Each row has a unique shipmentId
    const shipmentId = rowData?.shipmentId;
    // Use a ref to prevent multiple fetches on re-renders
    const hasFetchedRef = useRef(false);
  
    // Define the fetch logic only once

  
    // Trigger the fetch once per expanded row
    useEffect(() => {
        if (!shipmentId || !TE_ID || hasFetchedRef.current) return;
        hasFetchedRef.current = true;
    
        fetchShipmentDetails(executeGet, TE_ID, shipmentId)
          .then((data) => setShipmentData(data))
          .catch((err) => setError(err.message));
      }, [shipmentId, TE_ID, executeGet]);
    // We must call all hooks unconditionally; handle loading/error after.
    // 1) If the API is still in progress:
    if (loading) {
      return <LoaderComponent/>;
    }
    // 2) If there was an error:
    if (error) {
      return <Typography color="error">{error}</Typography>;
    }
    // 3) If the fetch finished but we have no data yet:
    if (!shipmentData) {
      return <Typography>Loading shipment details...</Typography>;
    }
  
    // The child array containing the actual details
    const consigneeDetails = Array.isArray(shipmentData.data.tcShipmentConsigneeDetails)
      ? shipmentData.data.tcShipmentConsigneeDetails
      : [];
  console.log(shipmentData)
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          p: 5,
          gap: 4,
          width: '100%',
        }}
      >
        <Box sx={{ width: '100%', textAlign: 'left', mb: 3 }} display="grid">
          <Typography variant="body2" fontWeight="400" sx={{ mb: 1 }}>
            Shipment Details
          </Typography>
          <CustomTable
            columns={detailColumns}
            data={consigneeDetails}
            enableTopToolbar={false}
            enableRowActions={false}
            enableBottomToolbar={false}
            // Show a custom message if the array is empty
      
          />
        </Box>
        <Divider />
      </Box>
    );
  });
  
  export default RenderDetailPanel;
  